import { render, staticRenderFns } from "./appscreens.vue?vue&type=template&id=b8aedac0&scoped=true"
import script from "./appscreens.vue?vue&type=script&lang=js"
export * from "./appscreens.vue?vue&type=script&lang=js"
import style0 from "./appscreens.vue?vue&type=style&index=0&id=b8aedac0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8aedac0",
  null
  
)

export default component.exports